export default "/assets/images/mila-living-room-people.5cdd389168275dae.jpg";